<template>
  <b-card class="balance-container my-border">
    <div class="text-dark font-weight-bolder mx-2 mb-2 my-font-title d-flex justify-content-between">
      <div>Balance de Tiempo Trabajado</div>
    </div>
    <b-row class="h-100">
      <b-col xl="3" lg="3" md="6" sm="6" cols="6">
        <div class="circle-container">
          <div class="circle border p-1">
            <div class="my-font-title text-dark font-weight-bolder">2</div>
            <div class="my-font-description text-secondary">
              Horas Trabajadas
            </div>
          </div>
        </div>
        <div class="info-container">
          <div class="text-secondary">Personal</div>
          <div class="text-dark">Entre 0 dias</div>
        </div>
      </b-col>
      <b-col xl="3" lg="3" md="6" sm="6" cols="6">
        <div class="circle-container">
          <div class="circle border p-1">
            <div class="my-font-title text-dark font-weight-bolder">5</div>
            <div class="my-font-description text-secondary">
              Dias de Vacaciones
            </div>
          </div>
        </div>
        <div class="info-container">
          <div class="text-secondary">Personal</div>
          <div class="text-dark">Entre 0 dias</div>
        </div>
      </b-col>
      <b-col xl="3" lg="3" md="6" sm="6" cols="6">
        <div class="circle-container">
          <div class="circle border p-1">
            <div class="my-font-title text-dark font-weight-bolder">2</div>
            <div class="my-font-description text-secondary">
              Horas Trabajadas
            </div>
          </div>
        </div>
        <div class="info-container">
          <div class="text-secondary">Personal</div>
          <div class="text-dark">Entre 0 dias</div>
        </div>
      </b-col>
      <b-col xl="3" lg="3" md="6" sm="6" cols="6">
        <div class="circle-container">
          <div class="circle border p-1">
            <div class="my-font-title text-dark font-weight-bolder">2</div>
            <div class="my-font-description text-secondary">
              Horas Trabajadas
            </div>
          </div>
        </div>
        <div class="info-container">
          <div class="text-secondary">Personal</div>
          <div class="text-dark">Entre 0 dias</div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.balance-container {
  width: 100%;
  padding: 0 10px 10px 10px;
}

.circle-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.info-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.circle {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.my-font-title {
  font-size: 22px;
}
.my-font-description {
  font-size: 14px;
  text-align: center;
}
</style>